import MetaTags from "react-meta-tags";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap";
import axios from "axios";
//redux
import { useSelector, useDispatch } from "react-redux";
import { getTokenFromLocalStorage } from "../../helpers/helpers";

import { withRouter, Link } from "react-router-dom";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// actions
import { loginUser, apiError, socialLogin } from "../../store/actions";

import moment from "moment";
// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/favicon.ico";
import { API_URL, sitename } from "../../constants/constants";
import { getAccessExpiration } from "../../helpers/repository";


const Login = (props) => {
  const [value, setValue] = useState("");
  const [accessExpired, setAccessExpired] = useState("");

  const dispatch = useDispatch();
  let errors = useSelector((state) => state?.CommonState?.errors ?? []);
  if (errors["message"] !== undefined) {
    errors = errors.message[0];
  }
  useEffect(() => {
    dispatch(apiError(""));
    let token = localStorage.getItem("token");
    if (![undefined, null, ""].includes(token)) {
      props.history.push("/welcome");
    }
    getAccessExpiration()
      .then((res) => {
        const today = moment();
        const expires_at = res?.data?.data?.access_expiration?.expires_at;
        const isAccessExpired = moment(today).isAfter(expires_at);
        setAccessExpired(isAccessExpired);
        setValue(expires_at ?? "");
      })
      .catch((e) => {
        console.log("errror");
      });
  }, []);

  // handleValidSubmit
  const handleValidSubmit = (event, values) => {
    event.preventDefault();
    dispatch(loginUser(values, props.history));
  };

  return (
    <React.Fragment>
      <MetaTags>
        <title>{sitename}</title>
      </MetaTags>

      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Sign in to continue to {sitename}.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            style={{
                              width: "80%",
                              height: "80%",
                            }}
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <AvForm
                      className="form-horizontal"
                      onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v);
                      }}
                    >
                      {errors && errors.length ? (
                        <Alert color="danger">{errors}</Alert>
                      ) : null}

                      <div className="mb-3">
                        <AvField
                          name="email"
                          label="Email"
                          value=""
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <AvField
                          name="password"
                          label="Password"
                          value=""
                          type="password"
                          required
                          placeholder="Enter Password"
                        />
                      </div>
                      {![undefined, null, ""].includes(value) ? (
                        <label
                          className={`form-check-label ${
                            accessExpired ? "text-danger" : "text-success"
                          }`}
                        >
                          {`Access Expiration ${value}`}
                        </label>
                      ) : null}

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                        >
                          Log In
                        </button>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  return { ...state.Layout };
};

export default connect(mapStateToProps, {})(Login);
